import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Shield } from 'lucide-react';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already acknowledged the banner
    const hasAcknowledged = localStorage.getItem('cookieBannerAcknowledged');
    if (!hasAcknowledged) {
      // Show banner after 1 second
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAcknowledge = () => {
    localStorage.setItem('cookieBannerAcknowledged', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl border-2 border-blue-200 overflow-hidden">
        <div className="p-6 sm:p-8">
          <div className="flex items-start gap-4">
            {/* Icon */}
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <Shield className="w-6 h-6 text-green-600" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
                Datenschutzfreundlich: Keine Cookies!
              </h3>
              <div className="text-sm sm:text-base text-gray-700 space-y-2">
                <p>
                  <strong className="text-green-700">Gute Nachricht:</strong> Diese Website verwendet <strong>keine Cookies</strong> und setzt <strong>keine Tracking-Tools</strong> ein.
                </p>
                <p>
                  Wir respektieren Ihre Privatsphäre. Es gibt kein Google Analytics, kein Facebook Pixel und keine Verhaltensanalyse.
                  Nur technisch notwendige Daten (z.B. für Formulareinreichungen) werden verarbeitet.
                </p>
                <p className="text-xs text-gray-600">
                  Mehr erfahren Sie in unserer{' '}
                  <a href="/datenschutz" className="text-blue-600 hover:underline font-medium">
                    Datenschutzerklärung
                  </a>
                  .
                </p>
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={handleAcknowledge}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Schließen"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Action Buttons */}
          <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button
              onClick={handleAcknowledge}
              className="bg-green-600 hover:bg-green-700 text-white flex-1 sm:flex-none"
            >
              Verstanden
            </Button>
            <a href="/datenschutz" className="flex-1 sm:flex-none">
              <Button
                variant="outline"
                className="w-full border-blue-300 text-blue-700 hover:bg-blue-50"
              >
                Datenschutzerklärung lesen
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
